import { render, staticRenderFns } from "./NosCategoriesItemPopup.vue?vue&type=template&id=59ab42a9&scoped=true&"
import script from "./NosCategoriesItemPopup.vue?vue&type=script&lang=js&"
export * from "./NosCategoriesItemPopup.vue?vue&type=script&lang=js&"
import style0 from "./NosCategoriesItemPopup.vue?vue&type=style&index=0&id=59ab42a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab42a9",
  null
  
)

export default component.exports